import classnames from "classnames";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import styles from "./close-button.css";

interface CloseButtonProps {
    className?: string;
    onClick: () => void;
}

export default function CloseButton({ className, onClick }: CloseButtonProps): JSX.Element {
    return (
        <button onClick={onClick} className={classnames(className, styles.button)}>
            <SVGIcon name="cross-thin" />
        </button>
    );
}
